module.exports = __webpack_public_path__ + "img/arrow-left.6aa468c5.svg";